import qs from 'qs';

const PollTemplateActions = {
    namespaced: true,

    state: {
        pollTemplateActionsData: [],
    },

    getters: {
        pollTemplateActionsData (state) {
            return state.pollTemplateActionsData;
        },
    },

    mutations: {

        /**
         * Установить значение pollTemplateActions
         * @param state
         * @param items
         */
        setArr (state, { items }) {
            state['pollTemplateActionsData'] = items;
        },

        /**
         * Обновить значение элемента pollTemplateActions
         * @param state
         * @param item
         * @param index
         */
        setItem (state, { item, index }) {
            state['pollTemplateActionsData'][index] = item;
        },

        /**
         * Добавить значение элемента pollTemplateActions
         * @param state
         * @param item
         */
        addItem (state, { item }) {
            state['pollTemplateActionsData'].push(item);
        },

        /**
         * Удалить элемент из pollTemplateActions
         * @param state
         * @param item
         */
        remove (state, { item }) {
            state['pollTemplateActionsData'] = state['pollTemplateActionsData'].filter(iItem => iItem !== item);
        },
    },


    actions: {

        /**
         * Получение данных по pollTemplateActions
         * @param commit
         * @param dispatch
         * @param getters
         * @param rootGetters
         * @returns {Promise<any>}
         */
        getPollTemplateActionsData ({ commit, dispatch, getters, rootGetters }) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                axios({
                    url: rootGetters.rootUrl +  'list/index',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.pollTemplateActions,
                    }),
                }).then(response => (
                    commit('setArr', {
                        items: response.data
                    }),
                        dispatch('loading/isLoading', false, {root:true}),
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по шаблонам программ получены.'),
                        resolve()
                )).catch(err => {
                        dispatch('loading/isLoading', false, {root:true}),
                        console.log('ERROR IN pollTemplateActions.js | getPollTemplateActionsData : ' + err);
                        window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка в получении данных по шаблонам программ!'),
                        reject(err);
                });
            })
        },

        /**
         * Сохранение данных по pollTemplateActions
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        savePollTemplateActionsData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                const str = JSON.stringify(data.data);
                axios({
                    url: rootGetters.rootUrl + 'list/save',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.pollTemplateActions,
                    }),
                }).then(response => {
                    console.log(response.data);
                    // Если редактирование
                    if (data.index !== -1) {
                        commit('setItem', {
                            item: data.data,
                            index: data.index
                        });
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по шаблонам программ успешно отредактированы!');

                    // Если сохранение нового
                    } else {
                      data.data.pollTemplateActionsId = response.data[0].pollTemplateActionsId;
                        commit('addItem', {
                            item: data.data
                        });
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Новый шаблон программ успешно создан!');
                    }
                    resolve();
                }).catch(err => {
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при сохранении данных!');
                        console.log('ERROR IN pollTemplateActions.js | savePollTemplateActionsData : ' + err);
                        reject(err);
                });
            })
        },

        /**
         * Удаление записи из pollTemplateActions
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        removePollTemplateActionsData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});
                const str = JSON.stringify(data.item);
                axios({
                    url: rootGetters.rootUrl + 'list/delete',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.pollTemplateActions,
                    }),
                }).then(response => (
                    commit('remove', {
                        item: data.item
                    }),
                    dispatch('loading/isLoading', false, {root:true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Шаблон программ успешно удален!'),
                    resolve()
                )).catch(err => {
                    dispatch('loading/isLoading', false, {root:true});
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при удалении шаблона программ!'),
                    console.log('ERROR IN pollTemplateActions.js | removePollTemplateActionsData : ' + err);
                    reject(err);
                });
            })
        },
    },
};

export default PollTemplateActions;





// WEBPACK FOOTER //
// ./src/store/modules/pollTemplateActions.js